import { Form, Grid, Select } from '@approvalmax/ui/src/components';
import { domHelpers } from '@approvalmax/utils';
import { FC } from 'react';

import { TrackingCategorySelect } from '../TrackingCategorySelect/TrackingCategorySelect';
import { messages } from './SettingsSection.messages';
import { SettingsSectionProps } from './SettingsSection.types';

export const SettingsSection: FC<SettingsSectionProps> = (props) => {
    const { name, qa, accounts, trackingCategories } = props;

    return (
        <Form.Part>
            <Grid gap={16}>
                <Select
                    itemNameKey='text'
                    name={`${name}Account`}
                    qa={domHelpers.generateDataQa(qa, 'account')}
                    label={messages.defaultAccountLabel}
                    placeholder={messages.selectPlaceholder}
                    items={accounts}
                    autocomplete
                />

                {trackingCategories[0] && (
                    <TrackingCategorySelect
                        name={`${name}TrackingCategoryOptionIds.0`}
                        qa={domHelpers.generateDataQa(qa, 'tracking-category-1')}
                        label={trackingCategories[0].category.text}
                        items={trackingCategories[0].options}
                    />
                )}

                {trackingCategories[1] && (
                    <TrackingCategorySelect
                        name={`${name}TrackingCategoryOptionIds.1`}
                        qa={domHelpers.generateDataQa(qa, 'tracking-category-2')}
                        label={trackingCategories[1].category.text}
                        items={trackingCategories[1].options}
                    />
                )}
            </Grid>
        </Form.Part>
    );
};

SettingsSection.displayName = 'SettingsSection';
